import { hasTrial } from './has-trial.js';

export function getTotalHeadingString(subscription) {
  return hasTrial(subscription) ? 'Price after Trial' : 'Price';
}
